export const OneTimeCodeUrl = "GetOneTimeCode.srf";
export const OneTimeCodeTimeout = 30000;
